
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import Header, { Footer } from "../HomePage/header";
import { useNotification } from "../Notification/notification";
import "./addtocart.css";

export default function CartPage() {
  const { notify } = useNotification();
  const navigate = useNavigate();

  const [cartItems, setCartItems] = useState([]);
  const [isCompact, setIsCompact] = useState(false);
  const lastScrollY = useRef(0);

  // Load cart
  useEffect(() => {
    const storedCart = JSON.parse(localStorage.getItem("cart")) || [];

    const mappedCart = storedCart.map((item) => ({
      id: item.id,
      productName: item.productName || item.name,
      productPrice: item.productPrice || item.price,
      productImage: item.productImage || item.image || "",
      quantity: item.quantity || 1,
    }));

    setCartItems(mappedCart);
  }, []);

  // Update quantity
  const handleQuantityChange = (id, delta) => {
    const updatedCart = cartItems.map((item) =>
      item.id === id
        ? { ...item, quantity: Math.max(1, item.quantity + delta) }
        : item
    );

    setCartItems(updatedCart);
    localStorage.setItem("cart", JSON.stringify(updatedCart));
  };

  // Remove item
  const handleRemove = (id) => {
    const updatedCart = cartItems.filter((item) => item.id !== id);

    setCartItems(updatedCart);
    localStorage.setItem("cart", JSON.stringify(updatedCart));
  };

  // Subtotal
  const subtotal = cartItems.reduce(
    (sum, item) => sum + item.productPrice * item.quantity,
    0
  );

 
  const handleCheckout = () => {
    if (cartItems.length === 0) {
      notify("Your cart is empty!");
      return;
    }

    navigate("/checkout");
  };

  useEffect(() => {
    const handleScroll = () => {
      const currentScroll = window.scrollY;

      if (currentScroll > lastScrollY.current && currentScroll > 50) {
        setIsCompact(true);
      } else {
        setIsCompact(false);
      }

      lastScrollY.current = currentScroll;
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <Header />

      <div className="cart-page-container">
        <div className="cart-page-header">
          <h1>Shopping Cart</h1>
          <p>Review your selected products before checkout.</p>
        </div>

        {/* EMPTY CART */}
        {cartItems.length === 0 ? (
          <div className="cart-empty-state">
            <h2>Your cart is empty</h2>
            <p>Add products to continue with your order.</p>
            <button
              className="checkout-btn"
              onClick={() => navigate("/product")}
            >
              Browse Products
            </button>
          </div>
        ) : (
          <div className="cart-layout">
            {/* ITEMS */}
            <div className="cart-items">
              {cartItems.map((item) => (
                <div key={item.id} className="cart-item">
                  <img src={item.productImage} alt={item.productName} />

                  <div className="cart-item-info">
                    <h3>{item.productName}</h3>
                    <p>Rs {item.productPrice}</p>

                    <div className="quantity-controls">
                      <button onClick={() => handleQuantityChange(item.id, -1)}>
                        -
                      </button>

                      <span>{item.quantity}</span>

                      <button onClick={() => handleQuantityChange(item.id, 1)}>
                        +
                      </button>
                    </div>

                    <button
                      className="remove-btn"
                      onClick={() => handleRemove(item.id)}
                    >
                      Remove
                    </button>
                  </div>

                  <div className="item-total">
                    <p>Item Total</p>
                    <strong>
                      Rs {(item.productPrice * item.quantity).toFixed(2)}
                    </strong>
                  </div>
                </div>
              ))}
            </div>

            {/* SUMMARY */}
            <div className="cart-summary">
              <p className="summary-label">Order Summary</p>
              <h2>Subtotal: Rs {subtotal.toFixed(2)}</h2>

              <button onClick={handleCheckout} className="checkout-btn">
                Proceed to Checkout
              </button>
            </div>
          </div>
        )}
      </div>

      <Footer />
    </>
  );
}